import * as React from "react";
const SvgArrowLeft20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 14,
        fill: "black",
        viewBox: "0 0 9 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m8.414 2-5 5 5 5L7 13.414.586 7 7 .586 8.414 2Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowLeft20Px;
